import React, { useState, useEffect, useRef } from "react";
function Utilities() {
  const UtilitiesItem = [
    {
      thumbnail: "/images/ic_pig.png",
      title: "Đặt phòng trực tiếp",
      content: "Giá tốt nhất",
    },
    {
      thumbnail: "/images/ic_money_time.png",
      title: "Đặt phòng",
      content: "Không đặt cọc",
    },
    {
      thumbnail: "/images/ic_full_size.png",
      title: "Nhận phòng",
      content: "Trước 48h",
    },
    {
      thumbnail: "/images/ic_live_streaming.png",
      title: "Điều khiển phòng",
      content: "Bằng Tablet",
    },
  ];
  return (
    <div id="utilities">
      <div className="container">
        <div className="row">
          {UtilitiesItem.map((item, index) => {
            return (
              <div className="col-lg-3  col-6 utilitiesBox" key={index}>
                <div className="thumbnail">
                  <img src={item.thumbnail} alt="" />
                </div>
                <div className="contentBox">
                  <p>{item.title}</p>
                  <h5>{item.content}</h5>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default Utilities;
